module.exports = __webpack_public_path__ + "media/images/favicons/favicon-32x32-58177d9eddb9bfc21158ffe33ee3d162.png";